import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { WinController } from "@lib/titan2-slingo/dist/game/controller/WinController";
/**
* GameWinController.ts
*/
export class GameWinController extends WinController {
    handlePurchaseSpin() {
        // Overridden so that available wins are still shown after stake to spin, and so that they are never shown in replay.
        if (this.model.isSpin() && !this.model.isChooseCell() && !this.model.getSpinResultResolving() && !Service.isReplay()) {
            this.dispatchGame(SlingoEvent.AVAILABLE_WIN_START);
            let winAvailable = this.updateAvailableWins();
            if (winAvailable) {
                this.startWinTimer(200);
            }
        }
    }
    handleClearWin() {
        this.clearWinTimer.stop();
        this.dispatchGame(SlingoEvent.AVAILABLE_WIN_CLEAR);
        // TODO: look into why this override changing 1000 to 0 is needed.
        this.startWinTimer(0);
    }
}
//# sourceMappingURL=GameWinController.js.map